<template>
  <base-event-log-item
    :icon="icon"
    :icon-color="iconColor"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
  >
    <div class="text-overflow-ellipsis">
      <span class="font-weight-medium">Full Text PDF</span>
      <span class="font-weight-light">
        {{ verbs }}
      </span>
    </div>
  </base-event-log-item>
</template>

<script>
import BaseEventLogItem from './BaseEventLogItem';
import { ReferenceEventLog, Reference } from '@/models';
import { ReferenceEvent } from '@/enums';

const EVENT_TO_STYLE_PROPS = {
  [ReferenceEvent.FULL_TEXT_PDF_UPLOAD]: {
    verbs: 'uploaded',
    icon: { name: 'file_upload', color: 'success' },
  },
  [ReferenceEvent.FULL_TEXT_PDF_UPDATE]: {
    verbs: 'updated',
    icon: { name: 'file_upload', color: 'warning' },
  },
  [ReferenceEvent.FULL_TEXT_PDF_DELETE]: {
    verbs: 'deleted',
    icon: { name: 'file_upload', color: 'error' },
  },
};

export default {
  name: 'FullTextPdfEventLogItem',
  components: { BaseEventLogItem },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    reference: {
      type: Reference,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.styleProps.icon.name;
    },
    iconColor() {
      return this.styleProps.icon.color;
    },
    verbs() {
      return this.styleProps.verbs;
    },
    styleProps() {
      return EVENT_TO_STYLE_PROPS[this.referenceEventLog.event];
    },
  },
};
</script>
